import React, { Component } from 'react';
import { Modal, InputNumber, Spin, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

class AdjustFte extends Component {
    state = {
        data: [],
        loading: false,
        visible: false,
    }
    
    record = {}

    loadData = () => {
        const { date, investigationSiteId } = this.record;
        this.setState({ loading: true })
        const options = {
            url: API_URL.plan.queryChangeRequirementFte,
            data: {
                investigationSiteId,
                date: date ? date.slice(0, 10) : '',
            },
            dataType: 'json',
            doneResult: res => {
                const { data, notAssign } = res;
                this.setState({
                    data: (data || []).concat(notAssign || []),
                    loading: false
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    show = (record) => {
        this.record = record;
        this.setState({ visible: true }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.props;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    handleChange = (value, index) => {
        const { data } = this.state;
        data[index].fteValue = value;
        this.setState({ data });
    }

    getContent = () => {
        const { data } = this.state;
        return (
            <tbody>
                {
                    (data || []).map((item, index) => {
                        const { assignmentDetailId, requirementDetailId, requirementCode, userName, fteValue, status, handoverUserId } = item;
                        //|| handoverUserId 删除，不知道为什么要加这个判断
                        return (
                            <tr key={assignmentDetailId || requirementDetailId}>
                                <td className="td_left">{userName}</td>
                                <td className="td_middle">{requirementCode}</td>
                                <td className="td_right">
                                    <InputNumber
                                        step={0.1}
                                        precision={2}
                                        placeholder="请输入"
                                        value={fteValue}
                                        style={{ width: 120 }}
                                        disabled={status !== 'ACTIVE' || handoverUserId }
                                        onChange={value => this.handleChange(value, index)}
                                    />
                                </td>
                            </tr>
                        );
                    })
                }
            </tbody>
        );
    }

    confirm = () => {
        const { data } = this.state;
        const { investigationSiteId } = this.record;
        const params = { investigationSiteId };
        for (let i = 0, len = data.length; i < len; i++) {
            const { assignmentDetailId, requirementDetailId, fteValue } = data[i];
            if (!fteValue && fteValue !== 0) {
                return message.warning('已分配FTE不能为空');
            }
            if (assignmentDetailId) {
                params[`changeFteVos[${i}].assignmentDetailId`] = assignmentDetailId;
            } else {
                params[`changeFteVos[${i}].requirementDetailId`] = requirementDetailId;
            }
            params[`changeFteVos[${i}].fteValue`] = fteValue;
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.changeRequirementFte,
            data: params,
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, data } = this.state;
        const { title, investigationSiteCode, investigationSiteName } = this.record;
        const total = (data || []).reduce((fte, item) => fte + Number(item.fteValue), 0);
        return (
            <Modal
                title='FTE调整'
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <Spin spinning={loading}>
                    <div>{investigationSiteName}({investigationSiteCode})-{title}</div>
                    <table className="adjustFte" style={{ marginTop: 20 }}>
                        <thead>
                            <tr>
                                <td className="td_left bold">被分配人员</td>
                                <td className="td_middle bold">所属需求编号</td>
                                <td className="td_right bold">已分配FTE</td>
                            </tr>
                        </thead>
                        {this.getContent()}
                        <tfoot>
                            <tr>
                                <td className="td_left bold">合计</td>
                                <td className="td_middle bold"></td>
                                <td className="td_right bold">{(total || 0).toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </Spin>
            </Modal>
        );
    }
}

export default AdjustFte;


// WEBPACK FOOTER //
// ./src/components/plan/siteFte/components/AdjustFte.js